import { useEffect, useState } from 'react';
import {
  fetchBenefitDetail,
  type BenefitDetail,
} from '#/domains/preview/api/govBenefitApi';

type State = {
  detail: BenefitDetail | null;
  isLoading: boolean;
  error: string | null;
};

export function useBenefitDetail(serviceSeqNo: string) {
  const [state, setState] = useState<State>({
    detail: null,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    setState({ detail: null, isLoading: true, error: null });

    fetchBenefitDetail(serviceSeqNo, controller.signal)
      .then(detail => {
        setState({ detail, isLoading: false, error: null });
      })
      .catch((err: unknown) => {
        if ((err as { name?: string }).name === 'AbortError') return;
        setState({
          detail: null,
          isLoading: false,
          error:
            err instanceof Error
              ? err.message
              : '혜택 상세를 불러오지 못했어요.',
        });
      });

    return () => controller.abort();
  }, [serviceSeqNo]);

  return state;
}
